'use client';

import { c as _c } from "react/compiler-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ReactElement, ReactNode, useMemo } from 'react';
import { FontFamilies, ThemeMode, ThemeName, getTheme } from '../../libs/themes/index';
interface ThemeProviderProps {
  children: ReactNode;
  themeName: ThemeName;
  themeMode: ThemeMode;
  rtl?: boolean;
  locale?: string;
  fontFamilies?: FontFamilies;
  /** if nested ThemeProvider then CssBaseline should not be inserted */
  nested?: boolean;
}
export const ThemeProvider = t0 => {
  const $ = _c(12);
  const {
    themeName,
    themeMode,
    children,
    rtl: t1,
    locale: t2,
    nested,
    fontFamilies
  } = t0;
  const rtl = t1 === undefined ? false : t1;
  const locale = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== fontFamilies || $[1] !== locale || $[2] !== rtl || $[3] !== themeMode || $[4] !== themeName) {
    t3 = getTheme({
      themeName,
      themeMode,
      rtl,
      locale,
      fontFamilies
    });
    $[0] = fontFamilies;
    $[1] = locale;
    $[2] = rtl;
    $[3] = themeMode;
    $[4] = themeName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const theme = t3;
  let t4;
  if ($[6] !== nested) {
    t4 = nested !== true && <CssBaseline />;
    $[6] = nested;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== t4 || $[10] !== theme) {
    t5 = <MuiThemeProvider theme={theme}>{t4}{children}</MuiThemeProvider>;
    $[8] = children;
    $[9] = t4;
    $[10] = theme;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};